// Example activities for demo mode
import { Utensils, Pill, Stethoscope, Brain, Calendar, FileText } from 'lucide-react';

export const exampleActivities = [
  {
    id: 1,
    type: 'food',
    icon: Utensils,
    title: 'Logged breakfast macros in Zippy Food Tracker',
    time: '1 hour ago',
    color: 'text-orange-500 bg-orange-50',
  },
  {
    id: 2,
    type: 'medication',
    icon: Pill,
    title: 'Took Metformin 500mg',
    time: '2 hours ago',
    color: 'text-blue-500 bg-blue-50',
  },
  {
    id: 3,
    type: 'symptom',
    icon: Stethoscope,
    title: 'Logged mild headache',
    time: '4 hours ago',
    color: 'text-red-500 bg-red-50',
  },
  {
    id: 4,
    type: 'ai',
    icon: Brain,
    title: 'ZippyHealth AI generated food correlation insight',
    time: '6 hours ago',
    color: 'text-purple-500 bg-purple-50',
  },
  {
    id: 5,
    type: 'appointment',
    icon: Calendar,
    title: 'Scheduled follow-up with Dr. Smith',
    time: '1 day ago',
    color: 'text-green-500 bg-green-50',
  },
  {
    id: 6,
    type: 'note',
    icon: FileText,
    title: 'Added diet notes',
    time: '2 days ago',
    color: 'text-slate-500 bg-slate-50',
  },
]; 